import { IPolicyApplication } from '../../../../data/api/models';

export default class PolicyDetailHelper {

  public static sortPremiums(selectedQuote: IPolicyApplication) {
    const isAnnual = this.isAnnual(null, selectedQuote);
    const sortOrder = ['admiral', 'gold', 'platinum'];

    const ordering = {};
    for (let i = 0; i < sortOrder.length; i++) {
      ordering[sortOrder[i]] = i;
    }

    return selectedQuote.premiums.filter((premium) => {
      return (isAnnual && premium.schemeType !== 'Single Trip') || (!isAnnual && premium.schemeType === 'Single Trip');
    }).sort((a, b) => {
      return (ordering[a.scheme.coverLevel] - ordering[b.scheme.coverLevel]);
    });
  }

  public static isAnnual(policy, selectedQuote) {
    if (policy) {
      return policy.metadata.scheme_type === 'annual';
    }

    return selectedQuote.tripType === 'annual';
  }

}
